export default [
  {
    field: 'transactionId',
    label: 'autotopupregistrations.transactions_transaction_id_column_heading',
    tooltip: 'autotopupregistrations.transactions_transaction_id_tooltip',
    type: 'string',
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'topUpDatetime',
    label: 'autotopupregistrations.transactions_topup_datetime_column_heading',
    tooltip: 'autotopupregistrations.transactions_topup_datetime_tooltip',
    type: 'string',
    sortable: true,
    placeholder: ' ',
  },
  {
    field: 'status',
    label: 'autotopupregistrations.transactions_status_column_heading',
    tooltip: 'autotopupregistrations.transactions_status_tooltip',
    type: 'string',
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'autotopupregistrations.transactions_action_column_heading',
    tooltip: '',
    sortable: false,
    placeholder: ' ',
    action: true,
  },
];
